import mapboxgl from 'mapbox-gl';
import { getIncidentDescription, updateUrlParameters } from '@helpers';
import { defaultTheme } from 'styles';

const loadingSkeletonHTML = (incidentID: string): string => `
    <div id="${incidentID}" class="shimmer-container">
        <div class="shimmer"></div>
        <div class="shimmer"></div>
        <div class="shimmer"></div>
        <div class="shimmer" style="width: 60%;"></div>
    </div>
    <style>
        .mapboxgl-popup-content {
            width: 240px;
            padding: 12px;
        }
        .shimmer-container {
            display: flex; 
            flex-direction: column; 
            gap: 12px; 
            width: 100%; 
            padding: 8px;
        }
        .shimmer {
            height: 12px; 
            border-radius: 4px;
            background: linear-gradient(90deg, #eee 25%, #f5f5f5 50%, #eee 75%);
            background-size: 200% 100%;
            animation: shimmer 1.5s infinite;
            padding: 
        }
        @keyframes shimmer {
            0%   { background-position: 200% 0; }
            100% { background-position: -200% 0; }
        }
        .mapboxgl-popup-close-button {
            font-size: 18px;
            width:24px;
        }
    </style>
`;

function openIncidentPopup(
    map: mapboxgl.Map,
    coordinates: [lat: number, lng: number],
    incidentNumber: string
) {
    const popup = new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(loadingSkeletonHTML(incidentNumber))
        .addTo(map);

    popup.getElement().style.fontFamily = defaultTheme.typography.fontFamily;

    const urlParameters = new URLSearchParams(window.location.search);
    const popupID = urlParameters.get('popupID');
    if (popupID !== incidentNumber) {
        updateUrlParameters({ popupID: `${incidentNumber}` });
    }

    popup.on('close', () => {
        updateUrlParameters({ popupID: undefined });
    });
}

export const openIncidentPopupAndFetchDescription = async (
    map: mapboxgl.Map,
    coordinates: [lat: number, lng: number],
    incidentNumber: string
): Promise<void> => {
    // Open popup immediately with loading spinner
    openIncidentPopup(map, coordinates, incidentNumber);

    // Find the popup content element
    const popupContent = document.querySelector(
        `.mapboxgl-popup [id="${incidentNumber}"]`
    );

    // Fetch description in background
    const description = await getIncidentDescription(incidentNumber);

    // Check if popup is still open
    if (!popupContent) {
        return;
    }

    // Update popup with fetched description
    popupContent.innerHTML = description;
};

export const closePopups = () => {
    const popups = document.querySelectorAll('.mapboxgl-popup');
    if (popups) {
        for (const popup of popups) popup.remove();
        updateUrlParameters({ popupID: undefined });
    }
};
